// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dodrio: PokeData = {
  "id": 85,
  "name": "dodrio",
  "height": 18,
  "weight": 852,
  "base_experience": 165,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "swords-dance",
    "wing-attack",
    "jump-kick",
    "fury-attack",
    "thrash",
    "leer",
    "growl",
    "supersonic",
    "peck",
    "drill-peck",
    "agility",
    "quick-attack",
    "rage",
    "mirror-move",
    "tri-attack",
    "pursuit",
    "uproar",
    "endeavor",
    "pluck",
    "acupressure",
    "double-hit",
    "lunge"
  ],
  "moves": [
    "jump-kick",
    "leer",
    "growl",
    "supersonic",
    "peck",
    "quick-attack",
    "tri-attack",
    "pursuit",
    "lunge",
    "purification",
    "scary-face",
    "scratch",
    "roost"
  ],
  "evolution_chain": {
    "id": 36,
    "item": null,
    "species": [
      {
        "name": "doduo",
        "order": 92,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dodrio",
        "order": 93,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 84,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 88,
    "speed": 156,
    "ability_power": 156
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
